<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>큐레이션 등록</div>
            </strong>
          </div>
          <div class="table-responsive">
            <table class="table b-table table-striped">
              <tbody class="">
              <!-- 활성화 start -->
              <tr class="form_tr" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">활성화</label>
                </td>

                <td class="" style="vertical-align:middle">
                  <c-switch type="text" variant="primary" v-model="queryParams.active_yn" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                </td>
              </tr>
              <!-- 활성화 end -->

              <!-- 슬롯번호 start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">슬롯번호</label>
                </td>

                <td class="">
                  <multiselect
                    v-model="mainSlotData"
                    :options="mainSlotNumberOptions"
                    :custom-label="mainSlotNumLabel"
                    :disabled="multiselectStatus"
                    placeholder="키비쥬얼 슬롯 번호"
                    label="num" style="width:570px" track-by="num"/>
                </td>
              </tr>
              <!-- 슬롯번호 end -->

              <!-- 분류문구 start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">분류문구</label>
                </td>
                <td class="">
                  <b-row class="pt-sm-12">
                    <b-col sm="10">
                      <b-form-input id="basicText" name="sub_title" type="text"
                                    v-model="queryParams.sub_title"
                                    v-validate="'required'"
                                    :class="{'is-invalid': errors.has('sub_title')}" placeholder="최대 10자까지 입력가능합니다."/>
                      <span v-show="errors.has('sub_title')" :class="{error: errors.has('sub_title')}">분류문구는 필수 항목 입니다.</span>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              <!-- 분류문구 end -->

              <!-- 제목 start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">제목</label>
                </td>
                <td class="">
                  <b-row class="pt-sm-12">
                    <b-col sm="10">
                      <b-form-input id="basicText" name="postsubject" type="text"
                                    v-model="queryParams.postsubject"
                                    v-validate="'required'"
                                    :class="{'is-invalid': errors.has('postsubject')}" placeholder="최대 15자까지 입력가능합니다."/>
                      <span v-show="errors.has('postsubject')" :class="{error: errors.has('postsubject')}">제목은 필수 항목 입니다.</span>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              <!-- 제목 end -->

              <!-- 활성기간 start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">활성기간 설정</label>
                </td>
                <td class="">
                  <b-row class="pt-sm-12">
                    <b-col sm="3">
                      <date-picker v-model="fullDate"
                                   type="date"
                                   style="width: 100%;"
                                   range
                                   placeholder="조회기간 선택"
                                   :lang="datepickerLang"/>
                    </b-col>
                  </b-row>
                </td>
              </tr>
              <!-- 활성기간 end -->

              <!-- 설명 start -->
              <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                <td width="150" style="background-color:#f1f1f1">
                  <label class="col-form-label">설명</label>
                </td>
                <td class="" colspan="4">
                  <textarea id="basicText" rows="10" cols="200" style="border:1px solid #c2cfd6" v-model="queryParams.explanation"/>
                </td>
              </tr>
              <!-- 설명 end -->
              </tbody>
            </table>
          </div>
        </b-card>

        <b-card>
          <div slot="header">
            <strong>
              <div>진열설정</div>
            </strong>
          </div>

          <div class="opt-table">
            <div class="d-flex justify-content-end mb-2">
              <button class="btn btn-primary" v-on:click="openOptPkg()">보고서 설정</button>
            </div>
            <table class="table table-striped table-hover table-bordered">
              <thead>
              <tr>
                <th class="text-center">번호</th>
                <th class="text-center">상품코드</th>
                <th class="text-center">상품명</th>
                <th class="text-center">뎁스</th>
                <th class="text-center">태그</th>
                <th class="text-center">등록일</th>
                <th class="text-center">등록자</th>
              </tr>
              </thead>
              <draggable
                v-model="reportPkgOptDatas.pkgOptList"
                tag="tbody"
                @start="dragStart"
                @end="dragEnd"
              >
                <tr
                  v-for="(item, index) in reportPkgOptDatas.pkgOptList"
                  :key="index"
                  :class="{ 'bg-info': drag && dragElement === index }"
                  @mouseover="mouseOver(index)"
                  @mouseout="mouseOut"
                >
                  <td class="text-center">{{ item.display_ord }}</td>
                  <td class="text-center">{{ item.dr_code }}</td>
                  <td class="text-center">{{ item.report_name }}</td>
                  <td class="text-center">{{ item.depth1_nm }} > {{item.depth2_nm}}</td>
                  <td class="tl">
                    <div style="float: left;">
                      <template v-for="tag in item.custom_tag">
                        <div class="badge badge-danger" style="font-size:14px; margin: 3px 3px 3px 3px; font-weight: 200;">{{ tag }}</div>
                      </template>
                    </div>
                  </td>
                  <td class="text-center">{{ item.reg_date }}</td>
                  <td class="text-center">{{ item.reg_id }}</td>
                </tr>
                <tr v-if="reportPkgOptDatas.pkgOptList.length === 0">
                  <td colspan="7" class="text-center my-2">
                    <strong>데이터가 없습니다.</strong>
                  </td>
                </tr>
              </draggable>
            </table>
          </div>
        </b-card>

      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">&nbsp;</b-col>
          <b-col sm="3" lg="4">&nbsp;</b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4"></b-col>
                <b-col md="4">
                  <b-button variant="warning" v-on:click="saveMainBanner()" v-if="formtype == 'update'" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #c5940d; font-size:15px">
                    <h5 style="margin-bottom:0px">
                      <i class="fa fa-edit"></i> 수정
                    </h5>
                  </b-button>
                  <b-button variant="success" v-on:click="saveMainBanner()" v-if="formtype == 'insert'" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px">
                    <h5 style="margin-bottom:0px">
                      <i class="fa fa-hand-o-up"></i> 등록
                    </h5>
                  </b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/site/mainmanagement'">
                    <h5 style="margin-bottom:0px">
                      <i class="fa fa-list-ul"></i> 목록
                    </h5>
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>


    <b-modal title="보고서 찾기" size="xl" v-model="formModal" @ok="formModal = false"
             no-close-on-backdrop no-close-on-esc hide-footer>
      <reportOptModal v-bind:reportOptions="reportOptions" v-bind:formModal="formModal" ref="reportOptModalRef"></reportOptModal>
      <hr />
      <span class="float-right" style="padding-right:20px;">
        <b-button variant="outline-primary" @click="addDrPkgOpt()">적용</b-button>
        <b-button variant="outline-success" @click="formModal = false">취소</b-button>
      </span>
    </b-modal>

  </div>
</template>
<script>


import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Vue from 'vue';
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import cSwitch from '../../../../../components/Switch'
const moment = require("moment")
import reportOptModal from './ReportOptModal';
import VeeValidate from 'vee-validate'
import _ from 'lodash';
import draggable from 'vuedraggable'

Vue.use(VeeValidate, {
  locale: 'ko'
})

export default {
  name: 'CurationManagementForm',
  components: {
    Multiselect,
    cSwitch,
    reportOptModal,
    draggable,
    DatePicker
  },
  data() {
    return {
      bannercode: '',
      PCimgFileCheck: true,
      MOimgFileCheck: true,
      newFlag: 'new',
      mainSlotNumberOptions: [],   // 슬롯 넘버 선택시 옵션
      mainSlotData: '',
      formtype: '',               //insert : 등록, update : 수정
      multiselectStatus: false, //multiselect 활성화
      queryParams: {
        postsubject: '',
        banner_type: 'curation',
        contents_type: 'img',
        img_url: '',
        img_width: 0,
        img_height: 0,
        landing_url: '',
        active_yn: '',
        slot_number: 1,
        explanation: '',
        listThumbnailFile: {'PC': [], 'MO': []},
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(3, 'months').format('YYYY-MM-DD'),
        reg_date: moment().format('YYYY-MM-DD'),
        mo_img_url: '',
        mo_img_width: 0,
        mo_img_height: 0,
        sub_title: '',        //분류문구
        tag: '',              //태그
        target_yn: 'Y',       //타겟설정 Y: 현재 N: 새창
        contents_html: '',    //내용
        slotNumberDatas: [],  //전체 슬롯 데이터
        targetSlotNumberData: {} //선택한 슬롯 데이터
      },

      formModal:false,
      reportOptions: {
        optItems: [],
        pkgItems: [],
      },
      reportList: [],
      reportPkgOptDatas: {
        pkgOptList: []
      },
      drag: false,
      dragElement: null,
      hover: false,
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },

      fieldItems: [{
        'display_ord': {
          'label': '번호',
          'class': 'text-center'
        }
      }, {
        'dr_code': {
          'label': '상품코드',
          'class': 'text-center'
        }
      }, {
        'report_name': {
          'label': '상품명',
          'class': 'text-center'
        }
      }, {
        'reg_date': {
          'label': '등록일',
          'class': 'text-center'
        }
      }, {
        'reg_id': {
          'label': '등록자',
          'class': 'text-center'
        }
      }],
      isCustomHashTag : false,
      fullDate: [],
      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },
    }
  },
  watch: {
    'queryParams.active_yn': function () {
      // 배너 상태가 활성화고 수정 페이지면 멀티셀렉트 활성화
      if (this.queryParams.active_yn === 'Y' && this.formtype === 'update') {
        this.multiselectStatus = false
      } else if (this.queryParams.active_yn === 'N' && this.formtype === 'update') {
        this.multiselectStatus = true
        // multiselect에 자기 코드로 선택
        this.mainSlotData = this.mainSlotNumberOptions.find(option => option.code === this.bannercode)
      }
    }
  },
  mounted: function() {
    var self = this
    self.formtype = self.$route.query.status
    self.$session.set('page_banner_type', self.queryParams.banner_type)
    if (self.formtype === 'update') {
      self.bannercode = self.$session.get('bannercode')
      self.getMainManagementData(self.bannercode)
    } else {
      var items = {code: 'newbanner', name: '현재 적용중', num: 1}
      self.mainSlotNumberOptions.push(items)
      self.mainSlotData = self.mainSlotNumberOptions
      self.multiselectStatus = true
    }

    // multiselect 생성 이후 값 조절을 위함
    setTimeout(function() {
      self.getSlotNumberOptions();
    }, 100);




  },
  methods: {
    dragStart(e) {
      this.drag = true;
      this.dragElement = e.oldIndex;
    },
    dragEnd() {
      this.drag = false;
      this.dragElement = null;
      this.dragChangeNo();
    },
    mouseOver(index) {
      this.dragElement = index;
    },
    mouseOut() {
      if (!this.drag) this.dragElement = null;
    },

    openOptPkg(){
      var self = this
      self.formModal = true
    },
    dragChangeNo() {

      this.reportPkgOptDatas.pkgOptList.forEach(function (el, idx, arr){
         el.display_ord= (idx + 1);
      });

      this.reportOptions.pkgItems = _.cloneDeep(this.reportPkgOptDatas.pkgOptList);
      console.log(this.reportPkgOptDatas.pkgOptList);
    },

    addDrPkgOpt() {
      var self = this;
      var newPkgOptList = [];
      self.queryParams.curationList = [];

      self.reportOptions.pkgItems.forEach(function (el, idx, arr){
        // 이미 pkgOptList에 있는 항목인지 확인합니다.
        var existingItem = self.reportPkgOptDatas.pkgOptList.find(item => item.dr_code === el.dr_code && item.display_ord === (idx + 1));

        // 만약 항목이 이미 존재하면 그것을 사용하고, 그렇지 않으면 새 항목을 만듭니다.
        var pkgOptData;
        if (existingItem) {
          pkgOptData = existingItem;
        } else {
          pkgOptData = {
            display_ord: (idx + 1),
            report_name: el.report_name,
            dr_code: el.dr_code,
            depth1_nm: el.depth1_nm,
            depth2_nm: el.depth2_nm,
            tag: el.tag
          };

          if (el.tag){
            pkgOptData.custom_tag =el.tag.split(/[,\s]+/);
          }
        }

        // pkgOptData를 newPkgOptList에 추가합니다.
        newPkgOptList.push(pkgOptData);
      });

      // 이제 newPkgOptList를 reportPkgOptDatas.pkgOptList로 설정합니다.
      self.reportPkgOptDatas.pkgOptList = newPkgOptList;
      self.queryParams.curationList = _.cloneDeep(newPkgOptList);
      self.formModal = false;

      console.log('self.reportPkgOptDatas >>>>',self.reportPkgOptDatas);
      console.log('self.reportOptions >>>>',self.reportOptions);
    },

    mainSlotNumLabel ({ name, num }) {
      return `${num} - ${name}`;
    },

    // 활성화된 1~5까지의 슬롯 번호를 가져옴
    getSlotNumberOptions () {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);
      self.$http.post('/api/select/slotNumberOptions?access_token=' + token, data, null)
        .then((result) => {
          var slotNumberDatas = [];
          slotNumberDatas = result.data;

          slotNumberDatas.forEach(function (el, idx, arr){
            var setSlotNum = el.slot_number;

            //신규등록일 경우 최초 newbanner가 들어가기 때문에 SlotNum + 1을 해준다.
            if(self.formtype != 'update'){
              setSlotNum = setSlotNum + 1;
            }

            //mainSlotNumberOptions 배열에 차례대로 push
            var items = { code: el.banner_code, name: el.postsubject, num: setSlotNum };
            self.mainSlotNumberOptions.push(items);

            // 오름차순 정렬
            self.mainSlotNumberOptions.sort(function(a, b) {
              return a.num < b.num ? -1 : a.num > b.num ? 1 : 0;
            });
          });

          // multiselect 초기값 세팅
          self.mainSlotNumberOptions.some(function (el, idx) {
            if (self.formtype === 'insert' && idx === 0) {
              self.mainSlotData = el;
              return true;
            }
            if (el.num === self.queryParams.slot_number) {
              self.mainSlotData = el;
              return true;
            }
            return false;
          });

          if (self.mainSlotNumberOptions.length < 5 && self.queryParams.active_yn == 'N'){
            var items = {code: self.bannercode, name: '마지막 슬롯', num: self.mainSlotNumberOptions.length +1 };
            self.mainSlotNumberOptions.push(items);
            self.mainSlotData = items;
          }
        })
    },


    // 배너 데이터 조회
    getMainManagementData(bannercode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/mainBannerData?access_token=' + token + '&bannercode=' + bannercode + '&banner_type=' + self.queryParams.banner_type)
        .then((result) => {
          self.queryParams = result.data;

          let curationList = self.queryParams.curationList;
          let price_list = '';

          curationList.forEach(function (el, idx, arr){
            price_list = '';
            price_list += '일반 PDF '+Number(el.min_normal_price).toLocaleString()+' ~ '+Number(el.max_normal_price).toLocaleString()+'원<br>';
            price_list += '원본 PDF '+Number(el.min_original_price).toLocaleString()+' ~ '+Number(el.max_original_price).toLocaleString()+'원<br>';
            price_list += '보안 PDF '+Number(el.min_security_price).toLocaleString()+' ~ '+Number(el.max_security_price).toLocaleString()+'원<br>';
            el.price_list = price_list;
          });

          this.fullDate = [
            moment(self.queryParams.start_date, "YYYY-MM-DD").toDate(),
            moment(self.queryParams.end_date, "YYYY-MM-DD").toDate()
          ];

          self.reportPkgOptDatas.pkgOptList = curationList;

          self.reportPkgOptDatas.pkgOptList.forEach(function (el, idx, arr){
            if (el.tag){
              el.custom_tag = el.tag.split(/[,\s]+/);
            }
          });

          self.reportOptions.pkgItems = _.cloneDeep(curationList);
        })
    },

    // 배너 저장 및 수정
    saveMainBanner() {

      var self = this;

      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");
          self.queryParams.reg_id = self.$session.get('userId');
          self.queryParams.slotNumberDatas = self.mainSlotNumberOptions;
          self.queryParams.targetSlotNumberData = self.mainSlotData;
          self.queryParams.curationList = self.reportPkgOptDatas.pkgOptList;

          //배너 활성화 최소 조건
          if (self.mainSlotNumberOptions.length == 1 && self.queryParams.active_yn=='N'){
            swal.fire('배너는 최소 1개 이상<br/> 게재되어야 합니다!', '', 'error');
            return;
          }

          /*
          else if (self.mainSlotNumberOptions.length == 5 && self.queryParams.active_yn=='Y'){
            swal.fire('배너 사용은 최대 5개까지 입니다.', '', 'error');
            return;
          }
          */

          if (self.queryParams.active_yn=='Y' && self.mainSlotData == null){
            swal.fire('변경하실 슬롯을 선택해주세요.', '', 'error');
            return;
          }

          // 모든 유효성 통과
          // 비활성화라면 slot_number 99 고정
          if (this.queryParams.active_yn=='N'){
            this.queryParams.slot_number = 99;
          }

          const startDt = moment(self.fullDate[0], "YYYY-MM-DD").format("YYYY-MM-DD");
          const endDt = moment(self.fullDate[1], "YYYY-MM-DD").format("YYYY-MM-DD");

          self.queryParams.start_date = startDt;
          self.queryParams.end_date = endDt;

          var token = sessionStorage.getItem("myToken");
          var param = encodeURI(JSON.stringify(self.queryParams));




          var data = new FormData();
          data.append('objs', param);
          if(self.formtype == 'insert'){
            self.$http.post('/api/insert/mainBanner?access_token='+token, data, null)
              .then((result) => {

                swal.fire({
                  type: 'success',
                  title: '배너가 등록되었습니다.',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                  window.location = "#/site/mainmanagement";
                });

              })
          }else if(self.formtype == 'update'){
            self.$http.post('/api/update/mainBanner?access_token='+token, data, null)
              .then((result) => {

                swal.fire({
                  type: 'success',
                  title: '배너가 수정되었습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                  //window.location = "#/site/mainmanagement";
                });
              })

          }
        } else {
          window.scrollTo(0,0);
        }
      })
    },
  }
}
</script>



<style lang="css" scoped>
.delete_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #f42f2d; font-size:15px}
.delete_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #f42f2d; font-size:15px}
.clear_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #55a0bb; font-size:15px}
.clear_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #55a0bb; font-size:15px}

.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
  padding:20px
}

.normal {
  background-color: grey;
}

.dragArea{
  min-height: 10px;
}

.sortable-chosen {
  opacity: 0.7;
  background-color:#dcdcdc;
}

.sortable-ghost {
  background-color:#dcdcdc;
}
.handle {
  padding: 5px;
  margin-right: 10px;
  border: solid #000 1px;
  cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}

.imgdiv {
  margin:0 auto;
  display: inline-table;
  border:1px solid #a3b6c0;
  min-width:1352px;
  min-height:360px;
}

.imgdivnone {
  margin:0 auto;
  display: inline-table;
  border:1px solid #ea0000;
  min-width:1352px;
  min-height:360px;
}

img {
  display: block;
  max-width:1350px;
  max-height:850px;
  width: auto;
  height: auto;
}

.imgfile {
  border:1px solid #c2cfd6; border-radius:4px; width:70%; float:left
}

.imgfilenone {
  border:1px solid #ea0000; border-radius:4px; width:70%; float:left
}

.imgnone {
  padding: 12px 24px;
  background-color: hsl(222, 100%, 95%);
  color: hsl(243, 80%, 62%);
  border-radius: 6px;
  box-shadow: 0 0 0 0 rgba(200, 25, 25, 0.7);
  animation: pulse 1.75s infinite cubic-bezier(0.66, 0, 0, 1);
}

@keyframes pulse {
  to {
    box-shadow: 0 0 0 30px rgba(200, 25, 25, 0);
  }
}
</style>
<style src="../../../../../../node_modules/daterangepicker/daterangepicker.css"></style>
<style src="../../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/site/main/component/curation/CurationManagementForm.vue